module.exports = __webpack_public_path__ + "img/US_ChaosRate_ua.c27d761d.webp";